/* запретить скролинг на числовых инпутах, чтобы колесиком нельзя ++ или -- значение */
document.addEventListener('wheel', function (event) {
  if (document.activeElement.type === 'number' && document.activeElement.classList.contains('noScrollNumber')) {
    document.activeElement.blur()
  }
})
